module.exports = __webpack_public_path__ + "img/3.28af14d6.jpg";